export class InvoiceDeliveryLog {
  public channelType: ChannelType;
  public channelAddress: string;
  public date: Date;
}

export type ChannelType = 'BANK' | 'POST' | 'INVOICE_CENTRAL' | 'EMAIL' | 'MOBILE';
